import { MemberInvite } from './MemberInvite'

export const AcceptPage = () => {
  return <MemberInvite />
}

export default AcceptPage
